export default __webpack_public_path__ + "static/Plots0041-c014af992ad0355d0b18d2c27f68a5e3.jpg";